const renderCorporateHierarchySection = ({company}) => {
  const dataPoints = company?.corporateHierarchy?.length;
  return dataPoints <= 2000;
};

export default renderCorporateHierarchySection;
